import { computed } from 'vue'
import { useMainStore } from '@/composables/store'
import { useSiteTemplate } from '@/composables/useSiteTemplate'
import { shouldShowAppOrderSyncPromotion } from '@/utils/successAppDownload'

export function useAppOrderSyncPromotion() {
  const store = useMainStore()
  const { templateKey } = useSiteTemplate()
  const config = computed(() => {
    const value = store.getSiteInfo()?.configData
    if (value && typeof value === 'object') return value
    try { return JSON.parse(value || '{}') || {} } catch { return {} }
  })
  const isTaiwanTemplate = computed(() => templateKey.value === 'default')
  const enabled = computed(() => shouldShowAppOrderSyncPromotion(config.value, templateKey.value))
  return { config, enabled, isTaiwanTemplate }
}
